import { render, staticRenderFns } from "./HistoricMirrorDetail.vue?vue&type=template&id=be7ffac0&scoped=true&"
import script from "./HistoricMirrorDetail.vue?vue&type=script&lang=js&"
export * from "./HistoricMirrorDetail.vue?vue&type=script&lang=js&"
import style0 from "./HistoricMirrorDetail.vue?vue&type=style&index=0&id=be7ffac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7ffac0",
  null
  
)

export default component.exports